var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0.0791016C4.52929 0.0791016 0.0790558 4.53029 0.0790558 10.0001C0.0790558 15.4698 4.52929 19.921 10 19.921C15.4707 19.921 19.921 15.4708 19.921 10.0001C19.921 4.53029 15.4707 0.0791016 10 0.0791016ZM9.00855 13.3705L5.62117 9.98315L7.0237 8.58062L9.00751 10.5644L12.9761 6.59586L14.3786 7.99839L9.00855 13.3705Z",
    fill: "#FE5F55"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.bf46dcc9b126753d0956248036cfdc7f.svg";
export { ForwardRef as ReactComponent };